import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';
import { SelfEvaluationRecord } from './_interfaces/self-evaluation-record.interface';

@Injectable()
export class SelfEvaluationService {

  constructor(private _httpService: BackendService) { }

  public getSelfEvaluation(cycleId: number): Observable<any> {
    return this._httpService.get('getSelfEvaluation', [], [
      { 'name': 'cycleID', 'value': cycleId as any }
    ]);
  }

  public saveSelfEvaluation(evaluation: SelfEvaluationRecord): Observable<any> {
    return this._httpService.post('saveSelfEvaluation', evaluation);
  }

  public sendSelfEvaluation(evaluation: SelfEvaluationRecord): Observable<any> {
    evaluation.send = true;
    return this._httpService.post('sendSelfEvaluation', evaluation);
  }

  public sendLastDayEmail(cycleId: number, forceSend: boolean, validate: boolean = false): Observable<any> {
    return this._httpService.post('sendSelfEvaluationLastDay', {
      'cycleId': cycleId,
      'forceSend': forceSend,
      'validate': validate
    });
  }

}
